import { FormTextInput } from '@ui-components/form/FormTextInput'
import { TextInputMode } from '@ui-components/global/ComponentProps'
import { JSX } from 'react'
import { FieldError, UseFormRegisterReturn } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { hasError } from '../utils'

interface OtherTextInputFieldProps {
  fieldError?: FieldError
  formFieldRef: UseFormRegisterReturn
  label?: string
  inputMode?: TextInputMode
  description?: string
  maxLength?: number
}

export const OtherTextInputField = ({
  label,
  fieldError,
  formFieldRef,
  inputMode,
  description,
  maxLength,
}: OtherTextInputFieldProps): JSX.Element => {
  const intl = useIntl()
  return (
    <FormTextInput
      required={true}
      inputMode={inputMode}
      maxLength={maxLength}
      label={label ?? intl.formatMessage({ id: 'common-other-label' })}
      error={hasError(fieldError) ? fieldError?.message : undefined}
      description={description}
      {...formFieldRef}
    />
  )
}
